import React from 'react';

import Text from '@components/common/Text/Text';

import css from './OneStat.module.scss';

type OneStatProps = {
    stat: any;
    color: string;
};

const OneStat = ({ stat, color }: OneStatProps) => {
    return (
        <div className={css.one_stat}>
            <div className={css.one_stat__content}>
                <h1 className={css.one_stat__content_title} style={{ color: color }}>
                    {stat.value}
                </h1>
                <div>
                    <Text customClass={css.one_stat__content_description} variant={'body_01'} color={'txt-primary'}>
                        {stat.key}
                    </Text>
                </div>
            </div>
        </div>
    );
};
export default OneStat;
